(() => {
  /**
   * SETTINGS OVERLAY
   * - Overlay global (fora de section)
   * - Não interfere no dock
   * - Fecha ao clicar fora
   * - Toggle fluido com thumb + drag
   */

  function initSettingsOverlay() {
    const trigger = document.querySelector('[data-settings-trigger]');
    const overlay = document.querySelector('.settings-overlay');

    if (!trigger || !overlay) return;

    // 🔒 garante que o overlay fique fora de qualquer stacking context do dock
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    const panel = overlay.querySelector('.settings-panel');

    /* ======================
       OPEN / CLOSE
    ====================== */

    function open() {
      overlay.hidden = false;
      document.documentElement.classList.add('settings-open');
    }

    function close() {
      overlay.hidden = true;
      document.documentElement.classList.remove('settings-open');
    }

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });

    // clique fora fecha
    overlay.addEventListener('click', (e) => {
      if (!panel || !panel.contains(e.target)) close();
    });

    // ESC fecha
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    /* ======================
       SEGMENTED CONTROLS
    ====================== */

    setupSegments(overlay);
  }

  /* ======================
     SEGMENTED CONTROL (thumb + drag fluido)
  ====================== */

  function setupSegments(root) {
    root.querySelectorAll('.settings-group[data-segment]').forEach((seg) => {
      const thumb = seg.querySelector('.settings-thumb');
      const buttons = Array.from(seg.querySelectorAll('.settings-option'));

      if (!thumb || buttons.length < 2) return;

      let activeIndex = Math.max(
        0,
        buttons.findIndex(b => b.classList.contains('is-active'))
      );

      let dragging = false;
      let startX = 0;
      let startTranslate = 0;

      const GAP = 4;
      const PADDING = 4;

      function calcSizes() {
        const rect = seg.getBoundingClientRect();
        const innerW = rect.width - PADDING * 2;
        const btnW = (innerW - GAP * (buttons.length - 1)) / buttons.length;
        return { btnW };
      }

      function setActive(index, animate = true) {
        index = Math.max(0, Math.min(buttons.length - 1, index));
        buttons.forEach(b => b.classList.remove('is-active'));
        buttons[index].classList.add('is-active');
        activeIndex = index;

        thumb.style.transition = animate
          ? 'transform 220ms cubic-bezier(.2,.8,.2,1)'
          : 'none';

        const { btnW } = calcSizes();
        const x = activeIndex * (btnW + GAP);
        thumb.style.width = `${btnW}px`;
        thumb.style.transform = `translateX(${x}px)`;
      }

      // clique normal
 seg.addEventListener('click', (e) => {
  // se acabou de arrastar, ignora o click final
  if (seg._draggedRecently) return;

  const rect = seg.getBoundingClientRect();
  const x = e.clientX - rect.left;

  // escolhe o índice pela posição do clique (metades/terços/etc)
  const idx = Math.floor((x / rect.width) * buttons.length);
  setActive(idx, true);
});

      // drag
      seg.addEventListener('pointerdown', (e) => {
        seg._draggedRecently = false;
        dragging = true;
        startX = e.clientX;

        const matrix = new DOMMatrixReadOnly(
          getComputedStyle(thumb).transform
        );
        startTranslate = matrix.m41 || 0;

        thumb.style.transition = 'none';
        seg.setPointerCapture?.(e.pointerId);
      });

seg.addEventListener('pointermove', (e) => {
  if (!dragging) return;

  const dx = e.clientX - startX;
  if (Math.abs(dx) > 6) seg._draggedRecently = true;

  const { btnW } = calcSizes();

  let next = startTranslate + dx;
  const minX = 0;
  const maxX = (buttons.length - 1) * (btnW + GAP);

  next = Math.max(minX, Math.min(maxX, next));
  thumb.style.transform = `translateX(${next}px)`;
});


      function endDrag() {
        if (!dragging) return;
        dragging = false;

        const { btnW } = calcSizes();
        const matrix = new DOMMatrixReadOnly(
          getComputedStyle(thumb).transform
        );
        const x = matrix.m41 || 0;
        const idx = Math.round(x / (btnW + GAP));

        setActive(idx, true);
        setTimeout(() => { seg._draggedRecently = false; }, 0);
      }

      seg.addEventListener('pointerup', endDrag);
      seg.addEventListener('pointercancel', endDrag);

      // init
      setActive(activeIndex, false);

      // recalcula em resize
      window.addEventListener('resize', () => {
        setActive(activeIndex, false);
      });
    });
  }

  /* ======================
     INIT SAFE
  ====================== */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSettingsOverlay);
  } else {
    initSettingsOverlay();
  }
})();